<template>
  <div class="appointment-doctor">
    <div class="appointment-doctor-top">
      <div class="appointment-doctor-top-left">
        <div class="appointment-doctor-top-left-avatar">
          <img
            :src="
              doctor.img_head
                ? `data:image/jpeg;base64,${doctor.img_head}`
                : doctor.sex_str === keyMap.sexMan
                ? man
                : female
            "
            alt=""
          />
        </div>
        <div class="appointment-doctor-top-left-info">
          <div class="appointment-doctor-top-left-info-name">
            <strong>
              {{ doctor.name }}
              <img
                v-if="doctor.feature_profession"
                src="@/assets/images/huangguan.png"
                alt=""
              >
            </strong>
            <span></span>
          </div>
          <div class="appointment-doctor-top-left-info-name">
            <span>{{ doctor.hospital_name }}-{{ doctor.department }} - {{ doctor.title }}</span>

          </div>
          <div
            class="appointment-doctor-top-left-info-name"
            v-if="doctor.diagnose_time"
          >
            <span>看诊时长：{{ doctor.diagnose_time }}分钟</span>
          </div>
          <div class="appointment-doctor-top-left-info-name appointment-doctor-top-left-info-rate">
            <span>
              预约时效：<van-rate
                color="rgb(252, 93, 87)"
                :value="doctor.ageing"
              />
            </span>
          </div>
          <div class="appointment-doctor-top-left-info-hospital">
            <span v-if="doctor.language">{{ doctor.language }}</span>
            <span>看诊费：{{ +doctor.price === 0 ? "" : doctor.price }}</span>
          </div>
          <div class="appointment-doctor-top-left-info-appointment">
            <span v-if="doctor.diagnose_location"> {{ doctor.diagnose_location }}门诊部 </span>
            <span>{{ doctor.online_type_names }}</span>
          </div>
        </div>
      </div>
      <div class="appointment-doctor-top-right">
        <!-- <div v-if="type == keyMap.triage && intentionDoctorList.some((item) => item.id == doctor.id)">
          <el-button
            v-if="isCart"
            type="primary"
            size="mini"
            plain
            @click="cancel(doctor)"
          >取消邀请 </el-button>
          <el-button
            v-else
            type="success"
            size="mini"
          >已邀请</el-button>
        </div> -->

        <el-button
          :type="+doctor.booking_mode === 1 ? 'primary' : 'warning'"
          size="mini"
          @click="select(doctor)"
        >{{ +doctor.booking_mode === 1 ? "预约" : "意向" }}
        </el-button>
      </div>
    </div>
    <div
      class="appointment-doctor-bottom"
      v-if="doctor.fee_remark"
    >
      <span>看诊费备注：{{ doctor.fee_remark }}</span>
    </div>
    <div
      class="appointment-doctor-bottom"
      v-if="doctor.disease"
    >
      擅长专病：{{ doctor.disease }}
    </div>
    <div
      class="appointment-doctor-bottom"
      v-if="doctor.good_at"
    >
      擅长：{{ doctor.good_at }}
    </div>
    <div
      class="appointment-doctor-bottom"
      v-if="doctor.feature_profession_desc"
    >
      特色专科：{{ doctor.feature_profession_desc }}
    </div>
  </div>
</template>

<script>
import keyMap from "@/constants/appointment.js";
import man from "@/assets/images/user_head_man.png";
import female from "@/assets/images/user_head_female.png";

export default {
  name: "doctor",
  props: {
    type: {
      type: Number,
      default: 1,
    },
    doctor: {
      type: Object,
      default: () => {},
    },
    intentionDoctorList: {
      type: Array,
      default: () => [],
    },
    isCart: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      man,
      female,
      keyMap,
    };
  },
  methods: {
    select(item) {
      this.$emit("select", item);
    },
    // 取消邀请
    cancel(item) {
      this.$emit("cancel", item);
    },
  },
};
</script>

<style scoped lang="scss">
.appointment-doctor {
  padding: 10px 10px;
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #eee;

  strong,
  span {
    margin-right: 15px;
    margin-bottom: 7px;
    display: flex;
    align-items: center;
  }
  .appointment-doctor-top {
    display: flex;
    flex-direction: row;
    align-items: center;
    .appointment-doctor-top-left {
      display: flex;
      flex-direction: row;
      flex: 1;
      align-items: center;
      .appointment-doctor-top-left-avatar {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 15px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .appointment-doctor-top-left-info {
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        .appointment-doctor-top-left-info-name {
          width: 100%;
          height: 30%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          span {
            font-size: 12px;
            color: #333;
            margin-right: 0.5rem;
          }
          img {
            width: 16px;
          }
        }
        .appointment-doctor-top-left-info-rate {
          justify-content: flex-start;
          align-items: center;
        }
        .appointment-doctor-top-left-info-hospital {
          width: 100%;
          height: 30%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          span {
            font-size: 0.8rem;
            color: #333;
            margin-right: 0.5rem;
          }
        }
        .appointment-doctor-top-left-info-appointment {
          width: 100%;
          height: 30%;
          display: flex;
          flex-direction: row;
          justify-content: flex-start;
          align-items: center;
          span {
            font-size: 0.8rem;
            color: #333;
            margin-right: 0.5rem;
          }
        }
      }
    }
    .appointment-doctor-top-right {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .appointment-doctor-bottom {
    display: flex;
    font-size: 12px;
    color: #333;
  }
}
</style>
